// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"Staff_gridContainer__3UAYj","card":"Staff_card__3-6xR","gridItem":"Staff_gridItem__KPnnh","topImage":"Staff_topImage__3Z2lq","title":"Staff_title__10tSM"};